module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Gift-620910adbf344e8e24aa01f576b00357.svg";